import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Button,
  Box,
  Grid,
} from "@mui/material";

import { PreviewPay } from "./panelPays/PreviewPay";
import { AddPay } from "./panelPays/AddPay";
import { EditPay } from "./panelPays/EditPay";
import { DeletePay } from "./panelPays/DeletePay";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import { useStyles } from "../../styles/Styles";
import { useFetchSections } from "../../hooks/useGetSections";
import { useFetchPays } from "../../hooks/useGetPays";
import { Loading } from "../sharedComponents/Loading";
import { DataNotFound } from "../sharedComponents/DataNotFound";

export const PaysPanel = ({ token, date, idDocument }) => {
  const [selectedDate, setSelectedDate] = useState(date);
  const [selectedPay, setSelectedPay] = useState(null);
  const [selectedIdPay, setSelectedIdPay] = useState(null);
  const [modalAdd, setOpenAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalPreviewOpen, setModalPreviewOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [selectedIdSection, setSelectedIdSection] = useState("");
  const { sections, loadingSection } = useFetchSections(token, idDocument);
  const { datos, loading } = useFetchPays(token, selectedDate, refresh, idDocument);
  const classes = useStyles();

  useEffect(() => {
    if (sections.length > 0 && !selectedIdSection) {
      setSelectedIdSection(sections[0]?.ID_SECCION);
    }
  }, [sections, selectedIdSection]);

  const filteredData = datos.filter((item) =>
    item.titulo.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Paper elevation={0}>
        {loadingSection ? (
          <Loading />
        ) : (
          <>
            <Box sx={{ height: "auto", margin: "0 5px 15px" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={7}>
                  <TextField
                    label="Buscar pays por título"
                    variant="outlined"
                    fullWidth
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={3}>
                  <TextField
                    label="Fecha"
                    type="date"
                    variant="outlined"
                    value={selectedDate}
                    onChange={(event) => setSelectedDate(event.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setOpenAdd(true)}
                    fullWidth
                    sx={{ height: "100%", borderRadius: "12px" }}
                  >
                    Agregar Pay
                  </Button>
                </Grid>
              </Grid>
            </Box>
            {loading ? (
              <Loading message="Cargando Pays..." />
            ) : filteredData.length === 0 ? (
              <DataNotFound />
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={classes.tableTitle}>Título</TableCell>
                    <TableCell style={classes.tableTitle}>Pay</TableCell>
                    <TableCell style={classes.tableTitle}>Sección</TableCell>
                    <TableCell style={classes.tableTitle}>Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredData.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.titulo}</TableCell>
                      <TableCell>
                        <Button
                          onClick={() => {
                            setSelectedPay(item);
                            setModalPreviewOpen(true);
                          }}
                          style={{ borderRadius: "12px" }}
                        >
                          <img
                            src={item.imagen}
                            alt={item.titulo}
                            style={{ width: "80px", height: "50px", objectFit: "cover" }}
                          />
                        </Button>
                      </TableCell>
                      <TableCell>
                        {sections.find(
                          (section) => section.ID_SECCION === item.seccion_id
                        )?.NOMBRE_SECCION || "Sección no encontrada"}
                      </TableCell>
                      <TableCell>
                        <BorderColorIcon
                          onClick={() => {
                            setSelectedPay(item);
                            setModalEdit(true);
                            setSelectedIdSection(item.seccion_id);
                          }}
                          style={{ marginRight: "10px", cursor: "pointer" }}
                        />
                        <DeleteIcon
                          onClick={() => {
                            setSelectedIdPay(item.id);
                            setModalDelete(true);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </>
        )}
      </Paper>
      
      <PreviewPay
        open={modalPreviewOpen}
        close={() => setModalPreviewOpen(false)}
        pay={selectedPay}
      />
      <AddPay
        token={token}
        open={modalAdd}
        close={() => setOpenAdd(false)}
        selectedDate={selectedDate}
        idDocument={idDocument}
        selectedIdSection={selectedIdSection}
        sections={sections}
        refresh={() => setRefresh(!refresh)}
      />
      <EditPay
        token={token}
        open={modalEdit}
        close={() => setModalEdit(false)}
        pay={selectedPay}
        selectedDate={selectedDate}
        selectedIdSection={selectedIdSection}
        sections={sections}
        refresh={() => setRefresh(!refresh)}
      />
      <DeletePay
        token={token}
        open={modalDelete}
        close={() => setModalDelete(false)}
        IdPay={selectedIdPay}
        refresh={() => setRefresh(!refresh)}
      />
    </>
  );
};
